// extracted by mini-css-extract-plugin
export default {"fixedContainer":"FilePreviewCard_fixedContainer__cAcRb"};